// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SubmitAcceptanceRequestModel from '../../model/submit-acceptance-request-model';
import SubmitAcceptanceRequestDTO from '../dto/submit-acceptance-request-dto';
import dtoSchema from '../schemas/submit-acceptance-request-schema';

export default abstract class SubmitAcceptanceRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SubmitAcceptanceRequestDTO>) {
    super();
    if (data) {
      this.description = data.description ?? undefined;
      this.projectId = data.projectId;
      this.workItemId = data.workItemId;
    }
  }
  /**
  */
  description?: string;
  /**
  * @type {uuid}
  */
  projectId?: string;
  /**
  * @type {int32}
  */
  workItemId?: number;

  static toModel(dto: DeepPartial<SubmitAcceptanceRequestDTO>): SubmitAcceptanceRequestModel;
  static toModel(dto: DeepPartial<SubmitAcceptanceRequestDTO> | undefined | null): SubmitAcceptanceRequestModel | undefined;
  static toModel(dto: DeepPartial<SubmitAcceptanceRequestDTO> | undefined | null): SubmitAcceptanceRequestModel | undefined {
    return dto ? new SubmitAcceptanceRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SubmitAcceptanceRequestModel> | SubmitAcceptanceRequestModel): SubmitAcceptanceRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      description: unwrapped.description,
      projectId: unwrapped.projectId,
      workItemId: unwrapped.workItemId,
    } as SubmitAcceptanceRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SubmitAcceptanceRequestModel, can not map to SubmitAcceptanceRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
